import styled from 'styled-components';
import {
  StyleLessButton,
  UnderlineLink
} from '../../../../CommonComponents/commonStyles';

export const ExportPrint = styled(UnderlineLink)`
  margin-left: 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: block;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  margin-left: 26px;
  cursor: pointer;
  @media (max-width: 990px) {
    margin-left: 0px;
  }
`;

export const StyleLessButtons = styled(StyleLessButton)`
  top: 42px;
  z-index: 100;
  margin-bottom: 25px;
  @media only screen and (max-width: 990px) {
    margin-bottom: 25px;
    top: 0;
  }
`;
